import { render } from "./PaymentPaypal.vue?vue&type=template&id=7f74a951"
import script from "./PaymentPaypal.vue?vue&type=script&lang=js"
export * from "./PaymentPaypal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__